import axios from "axios";
import { app } from "../config/config";

type TokenSetup = {
  data: { device_name: string | null };
};

const postRequestWithCredentials = async <T>(
  url: string,
  data: Record<string, unknown>
) => axios.post<T>(url, data, { withCredentials: true });

export class SsoApi {
  private paths = {
    setupLoginToken: "api/sso/v1/user/self/token/setup",
    approveLoginToken: "api/sso/v1/user/self/token/login",
  };

  public invokeSSOTokenSetup = async (token: string) => {
    const url = new URL(this.paths.setupLoginToken, app.ssoUrl);

    const response = await postRequestWithCredentials<TokenSetup>(url.href, {
      token,
    });

    return response.data;
  };

  public approveLoginToken = async (token: string) => {
    const url = new URL(this.paths.approveLoginToken, app.ssoUrl);

    const response = await postRequestWithCredentials(url.href, { token });
    return response.data;
  };
}
